import React from 'react';
import { Col, Row } from 'reactstrap';
import {
    faCheck,
    faTimes,
    faBellSlash,
    faRandom,
    faPlus,
    faClinicMedical,
} from '@fortawesome/free-solid-svg-icons';
import DashboardCard from './DashboardCard';
import { useSelector } from 'react-redux';

const PracticesStats = () => {
    const stalePracticesCount = useSelector(getStalePracticesCount);
    const mutedPracticesCount = useSelector(getMutedPracticesCount);
    const activePracticesCount = useSelector(getActivePracticesCount);
    const newPracticesCount = useSelector(getNewPracticesCount);
    const totalCount = useSelector(getTotalCount);
    const conversionPracticesCount = useSelector(getConversionPracticesCount);
    return (
        <Row className="sc-glass shadow sc-rounded p-2 py-4 mb-4 text-light">
            <Col lg="12" md="12" sm="12">
                <h2 className="d-none d-md-block">Current Statuses</h2>
                <h4 className="text-center d-md-none">Current Statuses</h4>
            </Col>
            <DashboardCard
                stat={stalePracticesCount}
                statName="Stale"
                filterName="stale"
                statIcon={faTimes}
                statColor="bg-danger"
            />
            <DashboardCard
                stat={mutedPracticesCount}
                statName="Muted"
                filterName="muted"
                statIcon={faBellSlash}
                statColor="bg-warning"
            />
            <DashboardCard
                stat={activePracticesCount}
                statName="Live"
                filterName="live"
                statIcon={faCheck}
                statColor="bg-success"
            />
            <DashboardCard
                stat={newPracticesCount}
                statName="New"
                filterName="new"
                statIcon={faPlus}
                statColor="bg-primary"
            />
            <DashboardCard
                stat={totalCount}
                statName={'Total Active'}
                filterName="all"
                statIcon={faClinicMedical}
                statColor={'bg-secondary'}
            />
            <DashboardCard
                stat={conversionPracticesCount}
                statName='Conversions'
                filterName="manual_conversions"
                statIcon={faRandom}
                statColor={'bg-bitwerx'}
            />
        </Row>
    );
};
const getStalePracticesCount = (state)=>state.practice.dashboardInfo?.stalePracticesCount;
const getMutedPracticesCount = (state)=>state.practice.dashboardInfo?.mutedPracticesCount;
const getActivePracticesCount = (state)=>state.practice.dashboardInfo?.activePracticesCount;
const getNewPracticesCount = (state)=>state.practice.dashboardInfo?.newPracticesCount;
const getTotalCount = (state)=>state.practice.dashboardInfo?.totalCount;
const getConversionPracticesCount = (state)=>state.practice.dashboardInfo?.conversionPracticesCount;

export default PracticesStats;
